export default __webpack_public_path__ + "static/webRotator/svg/432581db78ca96f44cd1901d5bbfec93.svg";